import classNames from "classnames"
import * as React from "react"

type TabOwnProps<E extends React.ElementType = React.ElementType> = {
  label: string
  active?: boolean
  as?: E
  className?: string
}

export type TabProps<E extends React.ElementType> = TabOwnProps<E> & Omit<React.ComponentProps<E>, keyof TabOwnProps>

const __DEFAULT_TAB_ELEMENT__ = "a"

export const Tab = <E extends React.ElementType = typeof __DEFAULT_TAB_ELEMENT__>({
  as,
  label,
  className,
  active = false,
  ...props
}: TabProps<E>) => {
  const Component = as || __DEFAULT_TAB_ELEMENT__

  return (
    <Component {...props} className={classNames("tabs__tab", active && "tabs__tab--active", className)}>
      {label}
    </Component>
  )
}
